import React from 'react';
import { Logo } from './ui';
import { Link as RouterLink } from 'react-router-dom';

const Footer: React.FC = () => (
  <footer className="flex h-20 w-full items-center justify-between px-4 md:px-6 border-t">
    <div className="flex items-center gap-2">
      <Logo />
      <span className="text-sm text-muted-foreground">© 2024 FF Automaton. All rights reserved.</span>
    </div>
    <nav className="flex gap-4">
      <RouterLink className="text-sm text-muted-foreground hover:underline" to="#">
        Privacy Policy
      </RouterLink>
      <RouterLink className="text-sm text-muted-foreground hover:underline" to="#">
        Terms of Service
      </RouterLink>
      <RouterLink className="text-sm text-muted-foreground hover:underline" to="#">
        Risk Disclosure
      </RouterLink>
    </nav>
  </footer>
);

export default Footer;